const calculationInputQuery = `
  query CalculationInput($comparisonId: UUID!) {
    calculationInput(comparisonId: $comparisonId) {
      commonTechnical {
        sessionId
        senderId
      }
      policyPolicyDetails {
        objectBuildings {
          addresses {
            postalCode
            houseNumber
            houseNumberAddition
            street
            city
          }
          roofConstructionType
          roofOrientation
        }
        salesDockComparisons {
          numberOfPanels
          usageElectricity
          powerFactor
          additionalCosts {
            description
            calculationType
            vatType
            vatPercentage
            calculationValue
            supplierId
          }
          hasShadowFormation
        }
      }
    }
  }
`;

export default calculationInputQuery;
